import styled, { css } from "styled-components";
import { experienceEasterPath } from "../../../../paths";

import { IScoreWrapperStyleProps } from "./interfaces";

export const ScoreWrapper = styled.div<IScoreWrapperStyleProps>`
    overflow: hidden;
    margin-top: 60px;
    height: 446px;
    ${p => p.isEaster && css`
        margin-top: 95px;
        margin-left: 116px;
        margin-right: 88px;
        margin-bottom: 32px;
        height: calc(100% - 60px - 180px - 92px);
    `}
    ${p =>
        p.isLow
            ? css`
                  height: 270px;
                  width: 720px;
                  margin: auto;
                  margin-top: 120px;
                  border-radius: 30px;
                  border: 2px solid black;
                  -webkit-mask-image: -webkit-radial-gradient(white, black);
              `
            : undefined}
`;

export const EasterBackground = styled.div`
    background-image: url("${experienceEasterPath}/easter-score-background.svg");
    background-size: 100% 100%;
    position: absolute;
    top: 54px;
    left: -9px;
    right: -6px;
    bottom: 196px;
    z-index: -1;
`;

const padding = 20;
export const ChristmasBackground = styled.div`
    background-color: ${p => p.theme.c.christmasBlue};
    box-shadow: 0 0 0 6px ${p => p.theme.c.christmasLightBlue} inset;
    position: absolute;
    top: ${95 - padding}px;
    left: ${116 - padding}px;
    right: ${88 - padding}px;
    bottom: ${237 - padding}px;
    z-index: -1;
`;

export const RhytLadderWrapper = styled.div`
    &.Completed {
        opacity: 0.4;
        pointer-events: none;
        transition: 2s;
    }
`;

export const Asset1Wrapper = styled.div`
    position: absolute;
    top: 120px;
    pointer-events: none;

    img {
        width: 480px;
    }
`;

export const Asset2Wrapper = styled.div`
    position: absolute;
    top: 350px;
    right: 0;
    pointer-events: none;
    img {
        width: 430px;
    }
`;

export const Asset3Wrapper = styled.div`
    position: absolute;
    top: 73px;
    right: 224px;
    pointer-events: none;
    img {
        width: 83px;
    }
`;
